import { createContext } from 'react';

const ListingTypeContext = createContext();

export const { Provider, Consumer } = ListingTypeContext;

export default ListingTypeContext;
